var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      fill: "currentColor"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zM28.5 14.5h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM5.5 14.5h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM23.425 9.075a.993.993 0 0 0 .707-.293l1.414-1.414a1 1 0 0 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 .707 1.707zM7.868 8.782a1 1 0 0 0 1.414-1.414L7.868 5.954a1 1 0 1 0-1.414 1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.669 9.166A8.5 8.5 0 1 0 10.646 22.1 3.457 3.457 0 0 1 12 24.744V27a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-2.173a3.276 3.276 0 0 1 1.193-2.6 8.5 8.5 0 0 0 .476-13.059zM18 27a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1h4zm1.971-6.357A5.19 5.19 0 0 0 18.061 24H17v-4h1a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2h1v4h-1.056a5.546 5.546 0 0 0-2.039-3.456 6.5 6.5 0 1 1 8.066.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.4a85d9ebd2d34346f8693156964d6aa6.svg";
export { ForwardRef as ReactComponent };